import React, { Fragment, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../global/header/Header";
import Footer from "../global/footer/Footer";
import { toast } from "react-toastify";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { Dialog, Transition } from "@headlessui/react";
import { HiXMark } from "react-icons/hi2";

export function rootLoader() {
  // Simulez un chargement de données ici si nécessaire
  return { data: "root data" };
}

function Root() {
  let [isOpen, setIsOpen] = useState(false)
  const [email, setEmail] = useState("");
  const [emailExist, setEmailExist] = useState(false);
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);

  useEffect(() => {
    if (!checkBoxChecked) {
      setTimeout(() => {
        setIsOpen(true);
      }, 15000);
    }
  }, [checkBoxChecked]);

  function closeModal() {
    setIsOpen(false)
  }

  function handleCheckBoxChange() {
    setCheckBoxChecked(!checkBoxChecked);
  }

  const checkEmailExists = async (email) => {
    const q = query(collection(db, "Subscribe"), where("email", "==", email));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  };

  const handleEmailChange = async (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
      if (inputEmail.trim() !== "") {
        const exists = await checkEmailExists(inputEmail);
        if (exists) {
          setEmailExist(true);
        }
      } else {
        setEmailExist(false);
      }
  };

  const handleSubscribe = async() => {
    const docRef = await addDoc(collection(db, "Subscribe"), {
      email: email,
      dateCreated: new Date()
    });
    closeModal()

    toast.success("Abonnez-vous à la bulletin avec succès !", {
      position: "top-right",
      autoClose: 3000
    });
  }

  return (
    <>
      <Header />
      <Outlet />
      <Footer />

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/65" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-200 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-200 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="flex justify-between sm:text-xl poppins-bold text-center leading-6 text-gray-900"
                  >
                    Abonnez-vous et obtenez 10%
                    <HiXMark
                      size={24}
                      className="hover:bg-pink-200 hover:text-pink-600 transition-all duration-300 hover:scale-110 cursor-pointer rounded-full"
                      onClick={closeModal}
                    />
                  </Dialog.Title>
                  <div className="mt-4 space-y-6">
                    <p className="text-sm text-gray-500 text-center">
                      Abonnez-vous à la newsletter pour recevoir des mises à
                      jour sur les nouveaux produits.
                    </p>

                    <div className="mt-1 relative rounded-md">
                      <input
                        id="email"
                        placeholder="Entrer votre e-mail"
                        type="email"
                        className="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                        onInput={handleEmailChange}
                      />
                      {emailExist && <p className="text-red-600 text-xs md:text-sm">Déjà existant</p>}
                    </div>
                  </div>

                  <div className="mt-2.5">
                    <button
                      type="button"
                      className={`w-full poppins-bold inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm text-white transition-all duration-300 focus:outline-none focus-visible:ring-2 ${emailExist ? 'bg-gray-400 cursor-not-allowed' : 'bg-black hover:bg-pink-600'}`}
                      onClick={handleSubscribe}
                      disabled={emailExist}
                    >
                      Abonnez-vous
                    </button>
                  </div>
                  {/* <div className="form-control mt-2">
                    <label className="cursor-pointer flex items-center">
                      <input type="checkbox" className="checkbox checkbox-xs me-2 border border-r-gray-500"
                        checked={checkBoxChecked}
                        onChange={handleCheckBoxChange}
                      />
                      <span className="label-text">N'affichez plus cette popup !</span>
                    </label>
                  </div> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default Root;
